import { DiabetesIndicatorBoxExam } from 'happ-icons/icons'
import { PressureHeart } from 'happ-icons/icons'
import { DownloadExam } from 'happ-icons/icons'
import React from 'react'
import '../style.css'
import { useSelector } from 'react-redux'

const ButtonExamDownload = ({ examHistory }) => {
    const { profile } = useSelector(state => state.auth);
    const clickExam = (event, exam) => {
        event.preventDefault();
        if (exam !== null) {
            window.open(exam)
        }
        return
    }
    return (
        examHistory ? (
            examHistory.map((item) => (
                <div
                    style={{ position: 'relative' }}
                    className={`${item.documentType === 'psaResults' && profile?.gender === 'F' ? 'hide-col' : ''} ${item.total === 0 ? 'col-md-10 col-sm-12 col-lg-10 pt-2 margin-r-l px-0 mt-2 mb-5 text-white text-center rounded-2 box-download-exam dark-grey-bg-color' : 'col-md-10 col-sm-12 col-lg-10 margin-r-l pt-2 px-0 mt-2 mb-5 text-white text-center primary-bg-color rounded-2 box-download-exam'}`}
                >
                    <div className='d-flex justify-content-between'>
                        <div className='d-flex'>
                            <div className='ms-3 mtt' >
                                <DiabetesIndicatorBoxExam
                                    style={{
                                        width: '40px',
                                        height: '45px',
                                    }}
                                />
                            </div>
                            <div className='text-start ps-3 pe-3'>
                                <>
                                    <h6 className='fw-bold' style={{ letterSpacing: 0.5 }}>{item.name}</h6>
                                    {item.total === 1 ? (
                                        <p style={{ fontSize: '13px', fontWeight: '', lineHeight: '1px' }}>{item.documents[0].date}</p>
                                    ) : null}
                                </>
                            </div>
                        </div>
                        {item.total === 1 ? (
                            <div className='me-3 mt-1'>
                                <DownloadExam 
                                    onClick={(e) => clickExam(e, item.documents[0].url)}
                                    style={{ cursor: 'pointer', marginTop: '-7px' }}
                                />
                            </div>
                        ) : null}
                    </div>
                    {item.total >= 2 ? (
                         <div style={{ position: 'absoulute' }} className={'d-flex flex-column border-bottom-container-exams blue-border'}>                          
                            {item.documents.map((document, pos) => (
                                <div
                                    key={pos}
                                    className={`mx-2 d-flex justify-content-between align-items-center py-1 px-3 bg-date-link rounded-3 mb-2 shadow-sm ${pos === 0 ? 'mt-2' : ''}` }
                                >
                                    <span className="text-dark">Fecha: {document.date}</span>
                                    <DownloadExam 
                                        size={10}
                                        onClick={(e) => clickExam(e, document.url)}
                                        className='icon-body'
                                        style={{ cursor: 'pointer' }}
                                    />
                                </div>
                            ))}
                        </div>
                    ) : null}
                </div>
            ))
        ) : null
    )
}

export default ButtonExamDownload